<div class="loadingMapFull" *ngIf="isDataLoading">
  <div class="flex_center fullHeight">
    <mat-spinner [diameter]="30" class="mr-3"></mat-spinner> Please wait while we load
  </div>
</div>

<div class="container">
  <div class="row mb-4 mt-2">
    <h4 class="d-block d-md-none">Contact List</h4>
    <button
      mat-flat-button
      color="primary"
      class="btn-prefix-icon btn-upload mt-3"
      (click)="openPopUp()"
      *ngIf="isCSVFileVisible"
    >
      <mat-icon>file_upload</mat-icon>
      Upload Contacts
    </button>
    <app-contact-table
      class="w-100 mt-4 mt-sm-0"
      [csvFileColumnList]="csvFileColumns"
      [csvRecordColumnList]="csvRecordColumns"
      [filter]="filter"
      (hideOptionsEvent)="hideUploadMenu($event)"
    >
    </app-contact-table>
  </div>
</div>

<ng-template #addNewFile>
  <div class="addGroupWrap">
    <button class="close" (click)="dialogRef.close(); clearData()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="col-sm-12">
      <h2 matDialogTitle class="text-left">Upload Contacts</h2>
    </div>
    <div mat-dialog-content>
      <form>
        <div class="clearfix">
          <div class="form-group col-md-12">
            <mat-form-field class="btn-block file-required">
              <mat-label class="file-name">File Name</mat-label>
              <input
                type="text"
                [ngModelOptions]="{ standalone: true }"
                matInput
                pattern="^[ A-Za-z0-9-_]*$"
                [(ngModel)]="fileName"
                required
                #file="ngModel"
              />
              <mat-error *ngIf="file.errors && file.errors.required" class="invalid-feedback ml-0">
                File name is required
              </mat-error>
              <mat-error *ngIf="file.errors && file.errors.pattern" class="invalid-feedback ml-0">
                Special Characters are not allowed</mat-error
              >
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-12">
          <input
            type="file"
            accept=".csv"
            name="file-7[]"
            id="file-7"
            (change)="onFileChange($event)"
            class="inputfile inputfile-6"
          />
          <label for="file-7">
            <span>
              <i *ngIf="uploadFileObject">{{ uploadFileObject.name }}</i>
            </span>
            <strong>
              <mat-icon inline="true" class="mr-2">upload_file</mat-icon>
              Choose a file
            </strong>
          </label>
          <mat-error *ngIf="isExcelFileTrue == false" class="invalid-feedback ml-0"> *Please upload CSV file</mat-error>
        </div>
        <div class="col-sm-12 supportedFormats">
          <small>Supported : <b>CSV only</b><br />Size limit : <b>1 MB</b></small>
          <a class="download-csv" [attr.href]="sampleCsvUrl">
            <i class="material-icons"> get_app </i>Download Sample CSV
          </a>
        </div>

        <div class="col-sm-12" *ngIf="automatedFlag">
          <mat-checkbox color="primary" (change)="onCheckboxChange($event)">
            Do you want to add contacts to automated campaign?
          </mat-checkbox>
        </div>
      </form>
    </div>
    <mat-dialog-actions>
      <div class="form-group footer text-right w-100">
        <button mat-button (click)="clearData()">Reset</button>
        <button
          class="ml-1"
          mat-flat-button
          color="primary"
          [disabled]="!fileName || (uploadFileObject | json) != '{}' || disableUpload"
          (click)="UploadFile(fileName)"
        >
          Upload & Save
        </button>
      </div>
    </mat-dialog-actions>
  </div>
</ng-template>
